<template>

    <el-col
      class="content"
      :xl="{ span: 18 }"
      :lg="{ span: 18 }"
      :md="{ span: 18 }"
      :xs="{ span: 24 }"
      :sm="{ span: 24 }"
    >
      <div class="mydoc">
        <div class="header" style="font-weight: 900">
          {{ $t('journalIntro.headerTitle') }}
        </div>
  
        <div class="mybody">
           <p>{{ $t('journalIntro.overview_new') }}</p>
           <p>{{ $t('journalIntro.scope_new') }}</p>
           <p>{{ $t('journalIntro.editorialBoardTitle_new') }}</p>
           <p>{{ $t('journalIntro.editorialBoardList_new') }}</p>
           <p>{{ $t('journalIntro.publicationInfo_new') }}</p>
           <p>{{ $t('journalIntro.submissionSystem_new') }}</p>
           <p>{{ $t('journalIntro.wechat_new') }}</p>
           <p>{{ $t('journalIntro.award_new') }}</p>
           <p>{{ $t('journalIntro.subscription_new') }}</p>

         <br><hr><br>

          <p>
            {{ $t('journalIntro.overview') }}
          </p>
          <p>{{ $t('journalIntro.scope') }}</p>
          <p>{{ $t('journalIntro.editorialBoardTitle') }}</p>

          <p v-for="(line, index) in $t('journalIntro.editorialBoardList').split('\n')" :key="index">
            &nbsp;&nbsp;&nbsp;&nbsp;{{ line }}
          </p>

          <p>
            {{ $t('journalIntro.publicationInfo') }}
          </p>
          <p>{{ $t('journalIntro.submissionSystem') }}</p>
          <p>
            {{ $t('journalIntro.wechat') }}
          </p>
          <p>
            {{ $t('journalIntro.award') }}
          </p>
          <p v-for="(line, index) in $t('journalIntro.subscription').split('\n')" :key="'sub-' + index">
            {{ line }}
          </p>
        </div>


      </div>
    </el-col>


</template>

<script>
import loginComponent from "@/components/loginComponent";

export default {
  name: "introduction",
  components: {
    loginComponent,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.el-row {
  //   background-color: white;
  margin: auto;
}

.introduction_pre {
  width: auto;
  margin: 10px 5px 10px 5px; /**边框距离 上右边下左 */
  background-color: white;
  overflow: hidden;
}
.introduction {
  border: 1px solid #b3c0d1;
  height: 920px;
  margin-bottom: 10px;
  border-radius: 5px;
  /* margin-top: 5px; */
}

.about {
  min-height: calc(100vh - 8rem);
}
.showappbox {
  display: flex;
  .left {
    text-align: left;
  }
}

.content {
  margin-top: 12px;
  .mylink {
    height: 18rem;
    border-radius: 4px;
    background: rgba($color: #ffffff, $alpha: 0.5);
    // box-shadow: 2px 3px 10px rgb(51, 72, 94);
    .mybody {
      //   padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .body-item {
        cursor: pointer;
      }
      .num {
        font-size: 55px;
        font-weight: bold;
      }
    }
  }
  .mydoc {
    border-radius: 4px;
    min-height: 20rem;
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    text-align: left;
    .mybody {
      //   background: linear-gradient(45deg, #34495e, #41b883);
      height: 940px;
      padding: 10px;
      background-color: white;
      overflow: auto;
    }
    p {
      color: black;
      text-indent: 30px;
      line-height: 24px;
      padding: 10px;
    }
  }
}
.header {
  padding: 10px;
  text-align: left;
  background-color: gainsboro;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid gainsboro;
}
</style>



// WEBPACK FOOTER //
// src/view/introduction.vue